<div class="card card-default">

    <div class="panel-heading modal-header panel-header-padding panel-header-radius">
        <div class="col-sm-6">
            <div ngbTooltip="Return to Scenario List" class="card-caption float-start"><a *ngIf="data"
                    (click)="showScenarioList()">{{data.exportedScenarioName}}</a></div>
        </div>
        <div class="col-sm-6">
            <button *ngIf="data&&!data.deletedDate" permission="delete-datastore-scenario" ngbTooltip="Delete Scenario"
                class="btn btn-sm sk-btn-light float-end" (click)="deleteScenario()" confirm>Delete
                Scenario</button>
            <button permission="export-datastore-scenario" ngbTooltip="Export Scenario"
                class="btn btn-sm sk-btn-light float-end" (click)="exportScenario()" confirm>Export Scenario</button>
            <button ngbTooltip="Return to Scenario List" class="btn btn-sm sk-btn-light float-end" type="button"
                (click)="showScenarioList()">Scenario List</button>
        </div>

    </div>

    <div class="panel-body panel-body-padding">

        <table class="table table-nonfluid">
            <thead>
            </thead>
            <tbody>
                <tr>
                    <td>
                        <label>Exported Scenario Id</label>
                        <div *ngIf="data">S{{('00000' + data.exportedScenarioId).slice(-6)}}</div>
                    </td>
                    <td>
                        <label>Exported Scenario Instance</label>
                        <div *ngIf="data">E{{('00000' + data.projectScenarioId).slice(-6)}}</div>
                    </td>
                    <td>
                        <label>Exported By User</label>
                        <div *ngIf="data">{{data.exportedByUser}}</div>
                    </td>
                    <td>
                        <label>Exported Date</label>
                        <div *ngIf="data">{{data.exportedDate | date:'dd/MM/yyyy'}}</div>
                    </td>
                    <td>
                        <label>Deleted By User</label>
                        <div *ngIf="data">{{data.deletedByUser}}</div>
                    </td>
                    <td>
                        <label>Deleted Date</label>
                        <div *ngIf="data">{{data.deletedDate | date:'dd/MM/yyyy'}}</div>
                    </td>
                    <td>
                        <label>Last Modified On</label>
                        <div *ngIf="data">{{data.lastUpdatedDate | date:'dd/MM/yyyy'}}</div>
                    </td>
                </tr>
                <tr>
                    <td>
                        <label *ngIf="project"
                            ngbTooltip="{{project.keyPerformanceIndicator1Label}}">{{project.keyPerformanceIndicator1Label
                            | elipsis: 30}}</label>
                        <div *ngIf="data&&project&&project.keyPerformanceIndicator1Label">
                            {{data.keyPerformanceIndicator1}}</div>
                    </td>
                    <td>
                        <label *ngIf="project"
                            ngbTooltip="{{project.keyPerformanceIndicator2Label}}">{{project.keyPerformanceIndicator2Label
                            | elipsis: 30}}</label>
                        <div *ngIf="data&&project&&project.keyPerformanceIndicator2Label">
                            {{data.keyPerformanceIndicator2}}</div>
                    </td>
                    <td>
                        <label *ngIf="project"
                            ngbTooltip="{{project.keyPerformanceIndicator3Label}}">{{project.keyPerformanceIndicator3Label
                            | elipsis: 30}}</label>
                        <div *ngIf="data&&project&&project.keyPerformanceIndicator3Label">
                            {{data.keyPerformanceIndicator3}}</div>
                    </td>
                    <td>
                        <label *ngIf="project"
                            ngbTooltip="{{project.keyPerformanceIndicator4Label}}">{{project.keyPerformanceIndicator4Label
                            | elipsis: 30}}</label>
                        <div *ngIf="data&&project&&project.keyPerformanceIndicator4Label">
                            {{data.keyPerformanceIndicator4}}</div>
                    </td>
                    <td>
                        <label *ngIf="project"
                            ngbTooltip="{{project.keyPerformanceIndicator5Label}}">{{project.keyPerformanceIndicator5Label
                            | elipsis: 30}}</label>
                        <div *ngIf="data&&project&&project.keyPerformanceIndicator5Label">
                            {{data.keyPerformanceIndicator5}}</div>
                    </td>
                    <td></td>
                    <td></td>
                </tr>
            </tbody>
        </table>
        <span *ngIf="data&&!data.deletedDate" class="float-end" style="color: darkgrey">
            <i>{{data.exportedByUser}} exported this scenario on {{data.exportedDate | date:'dd/MM/yyyy'}} at
                {{data.exportedDate | date:'hh:mm a'}}</i>
        </span>
        <span *ngIf="data&&data.deletedDate" class="float-end" style="color: #a94442">
            <i>{{data.deletedByUser}} deleted this scenario on {{data.deletedDate | date:'dd/MM/yyyy'}} at
                {{data.deletedDate | date:'hh:mm a'}}</i>
        </span>
    </div>
</div>

<div class="card card-default" permission="show-notes" permission-display="block" style="margin-top: 5px;">

    <div class="panel-heading modal-header panel-header-padding panel-header-radius">

        <div class="card-caption float-start">Notes</div>
        <button *ngIf="data&&!data.deletedDate" permission="modify-notes" ngbTooltip="Create Note"
            class="btn btn-sm sk-btn-light float-end" (click)="createNote()">Create Note</button>
        

    </div>

    <div class="panel-body panel-body-padding">
        <table class="table table-hover">
            <thead>
                <tr>
                    
                    <th nowrap>Ref</th>
                    <th nowrap>Last Modified On</th>
                    <th nowrap>Last Modified By</th>
                    <th nowrap>Last Note (Extract)</th>
                    <th nowrap>Last Modified Summary</th>
                    <th nowrap>Supporting Documents</th>
                    
                </tr>
            </thead>

            <tbody *ngIf="data">
                
                <ng-container *ngFor="let item of data.notes">
                    <tr (click)="showNotes(item)" class="clickable" [ngClass]="{'sk-notice sk-notice-danger contingent-red': item.deleted }"
                        *ngIf="isShowDeleted && item.deleted || !item.deleted">
                
                        <td nowrap>N{{('00000' + item.noteId).slice(-6)}}</td>
                        <td nowrap>{{item.audit.auditDate | date:'dd/MM/yyyy h:mm a'}}</td>
                        <td nowrap>{{item.audit.auditUser.name}}</td>
                        <td width="50%" style="text-transform: capitalize;">{{item.audit.auditNote | elipsis: 70}}</td>
                        <td width="50%" style="text-transform: capitalize;">{{item.audit.auditSummary}}</td>
                        <td style="padding: 0; padding-left:75px">
                
                            <span *ngIf="item.attachments.length > 0" style="color: #00529B">
                                <i style="font-size: 35px;" class="bi bi-paperclip"></i>
                                <span
                                    style="position:absolute; margin-right:5px; width:auto; padding: 1px 6px; border-radius: 50%; background-color: white; color: #00529B; border-color: #00529B; border-width:2px; border-style: solid; font-size: 12px; margin-top:23px; margin-left:-15px; ">{{item.attachments.length}}</span>
                            </span>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
        <i class="fas fa-info-circle" style="color: #00529b"></i> <i>Choose a Note to modify or use the Create Note
            button.</i>
        
        <a class="float-end" permission="show-deleted-notes" (click)="isShowDeleted=!isShowDeleted"><small class="sk-link"
                *ngIf="isShowDeleted">hide deleted</small><small *ngIf="!isShowDeleted" class="sk-link">show deleted</small></a>

    </div>

</div>